module.exports = __webpack_public_path__ + "img/Coursesquare.631c1757.png";